import { bind } from "@react-rxjs/core"
import { createSignal } from "@react-rxjs/utils"
import { startWith } from "rxjs/operators"

export enum MobileCreditTab {
  Rfqs = "rfqs",
  NewRfq = "newRfq",
  Trade = "trade",
}

const [internalMobileCreditTab$, setMobileCreditTab] =
  createSignal<MobileCreditTab>()

export { setMobileCreditTab }
const DEFAULT_TAB = MobileCreditTab.Rfqs

export const [useMobileCreditTab] = bind(
  internalMobileCreditTab$.pipe(startWith(DEFAULT_TAB)),
  DEFAULT_TAB,
)
